import { render, staticRenderFns } from "./FieldsetConfirmParts.vue?vue&type=template&id=4ec8b818&scoped=true"
import script from "./FieldsetConfirmParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetConfirmParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetConfirmParts.vue?vue&type=style&index=0&id=4ec8b818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8b818",
  null
  
)

export default component.exports